<mat-card>
    <mat-card-header>
       <mat-card-title class="popupHeader">
         <div class="mat-card-header-text" i18n>
           Region Data Validity
         </div>
       </mat-card-title>
   </mat-card-header>

   <mat-card-content>
    <div class="mainCard">
      <mat-card class="listView">
        <div class="listViewCard">
          <mat-list> 
          <mat-list-item *ngFor="let user of userList" [value]="user" [class.selected]="header === user.name" (click)="selectedUser(user)">
            <button class="leftIcon" mat-icon-button [style.visibility]="header === user.name ? 'visible':'hidden'">
              <mat-icon class="iconTyp">task_alt</mat-icon>
            </button>
            <p matListItemTitle class="listItem">{{user.name}}</p>
          </mat-list-item>
        </mat-list> 
        </div>
      </mat-card>

      <div class="regSettings">
        <div>
        <mat-form-field class="my-form-field">
          <input name="header" placeholder= {{splaceholder}} matInput [(ngModel)]="header" required>
        </mat-form-field>
        <mat-radio-group aria-label="Select an option" class="column" (change)="radioChange($event)" [(ngModel)]="selectionType" [value]="selectionType">
            <mat-radio-button value="1">
              <span class="wrap-mat-radio-label sectionText" i18n>Availability period</span>
            </mat-radio-button>

          <div [ngClass]="selectionType === '1' ? 'section1': 'section4'">
            <mat-form-field class="my-form-field sdStyle">
              <mat-label i18n>Choose a start date</mat-label>
              <div class="regSettings">
                  <input matInput [matDatepicker]="startpicker" [(ngModel)]="restriction.sDate" [min]="todayDate">
                  <mat-datepicker-toggle matIconSuffix [for]="startpicker">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
              </div>
              <mat-datepicker #startpicker></mat-datepicker>
              <mat-hint>DD.MM.YYYY</mat-hint>
            </mat-form-field>

            <mat-form-field class="my-form-field edStyle">
              <mat-label i18n>Choose an end date</mat-label>
              <div class="regSettings">
                  <input matInput [matDatepicker]="endpicker" [(ngModel)]="restriction.eDate" [min]="todayDate">
                  <mat-datepicker-toggle matIconSuffix [for]="endpicker">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
              </div>
              <mat-datepicker #endpicker></mat-datepicker>
              <mat-hint>DD.MM.YYYY</mat-hint>
          </mat-form-field>
          </div>

          <mat-radio-button value="2">
            <span class="wrap-mat-radio-label sectionText" i18n>Data synchronization interval</span>
          </mat-radio-button>

          <div [ngClass]="selectionType === '2' ? 'section2': 'section3'">
          <mat-form-field class="my-form-field regionFilterField">
            <mat-label i18n>Choose a start date</mat-label>
            <div class="regSettings">
                <input matInput [matDatepicker]="picker" [(ngModel)]="restriction.sDate" [min]="todayDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
            </div>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint>DD.MM.YYYY</mat-hint>
          </mat-form-field>

          <mat-form-field class="my-form-field durationText">
            <mat-label i18n>Duration in days</mat-label>
            <input matInput type="number" max="365" min="1" (focusout)="focusField($event)" [(ngModel)]="restriction.duration">
          </mat-form-field>
        </div>
        </mat-radio-group>
      </div>
      </div>
    </div>
   </mat-card-content>

   <mat-card-actions>
     <div class="buttonContent">
       <button mat-raised-button type="button" color="primary" (click)="onSave()" [disabled]="isSaveDisabled" i18n>SAVE</button>
     </div>
   </mat-card-actions>
 </mat-card>
